import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { offeringConfig } from "../offering_config";
import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { Text } from "../text";
import { TextLink } from "../text_link";
import { useWerqwiseAnalytics } from "./werqwise_analytics";
import { partnerConfig, testimonials } from "./werqwise_partner_config";

const Theme = lazyWithRetry(() => import("./werqwise_theme"));

const faqs = [
  {
    question: "When can I access the building and meeting room?",
    answer:
      "Accessing the meeting room will be possible only during the times of the reservation.",
  },
  {
    question:
      "How do I access the conference room once arriving at the location?",
    answer:
      "When you first arrive at the building, please check-in with the front desk.",
  },
  {
    question: "How do I modify or cancel a booking?",
    answer:
      "You may cancel or modify the date of your reservation 24 hours before your booking begins. In order to change your reservation, please reach out to the front-desk or reply to the confirmation email 24 hours before the reservation begins.",
  },
  {
    question: "How many people can I invite to the meeting?",
    answer: "You can invite as many guests as per the capacity of the room.",
  },
  {
    question: "Am I allowed to bring food into the conference room?",
    answer:
      "Cold refreshments and hot drinks are allowed in the room. Please be sure to leave the room clean once your reservation ends.",
  },
  {
    question: "Can I send food/equipment delivery before the meeting?",
    answer:
      "Only the host and its guests are allowed to bring in items to the conference room. The on-site staff cannot accept any type of delivery.",
  },
  {
    question:
      "How can I extend my meeting once I have already started my reservation?",
    answer: (
      <Text>
        <TextLink
          href={`/offerings/${offeringConfig.Werqwise.slugConfig.meetingRoom}`}
        >
          Use the website
        </TextLink>{" "}
        to book the additional time you need for your meeting room. Also, feel
        free to reach out to the front-desk for further assistance.
      </Text>
    ),
  },
  {
    question: "Do I have printer access?",
    answer: "Yes, please speak with someone at the front desk.",
  },
];

export function OfferingWerqwiseMeetingRoom() {
  useWerqwiseAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          testimonials,
          faqs,
          generalInfo: {
            title: `General information and cancellation policy`,
            bulletPoints: [
              {
                point: "Cancellation and Changes",
                text: "You may cancel your reservation 24 hours before the reservation begins.",
              },
              {
                point: "Opening hours",
                text: "Access to the building will be granted between 9 AM to 5:30 PM. Please note that it is not possible to access the building before 9 AM.",
              },
              {
                point: "Attendees",
                text: "Your booking gives access to a meeting room. You may invite as many attendees as the maximum capacity of the room.",
              },
              {
                point: "Health and safety",
                text: "We've updated our space to help you make better choices. From installing our new temperature gate to adding hand sanitizer fixtures, we have added a variety of different ways to stay healthy and clean.",
              },
            ],
          },
        }}
      />
    </Fragment>
  );
}
